import React, { useState } from 'react';
import { Button, Stack, IconButton, InputAdornment } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import CustomTextField from '../../../components/forms/theme-elements/CustomTextField';
import CustomFormLabel from '../../../components/forms/theme-elements/CustomFormLabel';
import toast from 'react-hot-toast';

const AuthResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const email = searchParams.get('email');
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v2/resetpassword`, {
        email,
        password,
        token
      });

      if (response.data.status==='Success') {
        toast.success(response.data.message);
        navigate('/auth/login');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (!email || !token) {
    return <div>Invalid reset link</div>;
  }

  return (
    <Stack mt={4} spacing={2} component="form" onSubmit={handleSubmit}>
      <CustomFormLabel htmlFor="new-password">New Password</CustomFormLabel>
      <CustomTextField
        id="new-password"
        variant="outlined"
        fullWidth
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <CustomFormLabel htmlFor="confirm-password">Confirm Password</CustomFormLabel>
      <CustomTextField
        id="confirm-password"
        variant="outlined"
        fullWidth
        type={showPassword ? 'text' : 'password'}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
        error={password !== confirmPassword}
        helperText={password !== confirmPassword ? 'Passwords do not match' : ''}
      />

      <Button
        color="primary"
        variant="contained"
        size="large"
        fullWidth
        type="submit"
        disabled={loading}
      >
        {loading ? 'Resetting...' : 'Reset Password'}
      </Button>
    </Stack>
  );
};

export default AuthResetPassword;